import React, { useState } from 'react';
import { Button } from 'cantarus-react-ui';
import { FieldDataStrings as Strings } from '../../../utils/config';
import AssetManagerPopUp from '../../PopUp/AssetManagerPopUp';

const FieldDataAssetManager = ({ fieldKey, fieldName, fieldValue, handleFieldDataTextChange }) => {

    const baseClass = 'td-field-data-asset-manager';

    const [showPopUp, setShowPopUp] = useState(false);

    const togglePopUp = () => {
        setShowPopUp(!showPopUp)
    }
    const clearAsset = () => {
        handleAssetChange(null)
    }
    const handleAssetChange = (assetUrl) => {
        handleFieldDataTextChange(fieldName, assetUrl);
    }
    return (
        <div className={baseClass}>
            {(typeof fieldValue === 'string') && <div className={`${baseClass}-image`} style={{ backgroundImage: `url("${encodeURI(fieldValue)}")` }} />}
            <Button
                classes={['small']}
                onClick={togglePopUp}
                text={(typeof fieldValue === 'string') ? Strings.changeAssetButton : Strings.selectAssetButton}
            />
            <Button
                classes={['small']}
                onClick={clearAsset}
                text={Strings.clearAssetButton}
                disabled={typeof fieldValue !== 'string'}
            />
            <AssetManagerPopUp show={showPopUp} togglePopUp={togglePopUp} handleAssetChange={handleAssetChange} />
        </div>
    );
}

export default FieldDataAssetManager;
